<template>
  <div
    class="flatfinder-resource-card"
    :class="{
      'flatfinder-resource-card--disabled': disabled,
      'flatfinder-resource-card--nested': level,
    }"
  >
    <div :style="{ 'padding-left': Math.max(0, level - 1) * 0.5 + 'em' }">
      <div>
        <div class="flatfinder-resource-card__title">{{ title }}</div>
        <div class="flatfinder-resource-card__subtitle">
          <div v-if="value" class="flatfinder-resource-card__model">
            {{ model }}
          </div>
          <div v-if="value && $path('template.name', value)" class="flatfinder-resource-card__residential-template">
            <FontAwesomeIcon :icon="['fal', 'puzzle-piece']" />
            {{ $path('template.name', value) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from '@/i18n'

function getTitle(value) {
  if (!value) return i18n.t('notset')
  return value.name || value.label
}

export { getTitle }
export default {
  props: {
    value: Object,
    disabled: Boolean,
  },
  computed: {
    title() {
      return getTitle(this.value)
    },
    model() {
      if (!this.value || !this.value.onModel) return
      let defaultValue =
        this.value.onModel == 'Residential' ? this.$tc('unit') : this.$tc(this.value.onModel.toLowerCase())

      switch (this.value.onModel) {
        default:
          return defaultValue
      }
    },
    level() {
      if (!this.value) return 0
      return this.value.level || 0
    },
  },
}
</script>

<style lang="scss">
.flatfinder-resource-card {
  line-height: 1;

  &--nested {
    & > div {
      display: flex;
      align-items: center;

      &:before {
        content: '└';
        opacity: 0.2;
        margin-right: 0.5em;
      }
    }
  }

  .select-modal__item--disabled & {
    text-decoration: line-through;
    pointer-events: none;
    opacity: 0.4;
  }

  &__title {
    font-weight: bold;
    font-size: 1rem;
  }

  &__subtitle {
    opacity: 0.5;
    font-size: 0.8em;
    margin-top: 0.4rem;

    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>
